import React, { useState, useEffect, useMemo, useRef } from 'react';
import LogConsole from './LogConsole';
import StatsTables from './StatsTables';
import PlanTable from './PlanTable';

const Dnevnice = () => {
    const [podaci, setPodaci] = useState([]);
    const [period, setPeriod] = useState('');
    const [sviRadnici, setSviRadnici] = useState([]); 
    const [sviPeriodi, setSviPeriodi] = useState([]); 
    const [showUploadModal, setShowUploadModal] = useState(false);
    const [showSaveModal, setShowSaveModal] = useState(false);
    const [showDeleteModal, setShowDeleteModal] = useState(false); 
    const [showViewModal, setShowViewModal] = useState(false);
    const [showGenerateModal, setShowGenerateModal] = useState(false);
    const [showStatsModal, setShowStatsModal] = useState(false); 
    const [showPdfModal, setShowPdfModal] = useState(false); 
    const [selectedFile, setSelectedFile] = useState(null);
    const [editingId, setEditingId] = useState(null); 
    const [stats, setStats] = useState({ radnici: [], po_danima: [], plan_rasporeda: {}, lista_vozila: [] });
    const [statsPeriod, setStatsPeriod] = useState(''); 
    const [showStats, setShowStats] = useState(false);
    const [statsEmpty, setStatsEmpty] = useState(false);
    const [sortStatsRadnik, setSortStatsRadnik] = useState({ key: 'id', direction: 'asc' });
    const [sortStatsDani, setSortStatsDani] = useState({ key: 'datum', direction: 'asc' });
    const [logovi, setLogovi] = useState(''); 
    const [isGenerating, setIsGenerating] = useState(false);
    const [isFinished, setIsFinished] = useState(false);
    
    // State za čuvanje plana pre upisa u bazu
    const [generatedPlan, setGeneratedPlan] = useState(null);
    const [targetPeriod, setTargetPeriod] = useState('');
    const [vozilaInfo, setVozilaInfo] = useState([]);

    const abortControllerRef = useRef(null); 
    const logRef = useRef(null);

    useEffect(() => {
        ucitajRadnike();
        ucitajPeriode();
        ucitajVozila();
    }, []);

    const ucitajRadnike = async () => {
        try {
            const response = await fetch('https://ecopell.ledscreen.rs/core/get-radnici/');
            const result = await response.json();
            setSviRadnici(result.radnici || []);
        } catch (err) { console.error("Greška radnici"); }
    };

    const ucitajPeriode = async () => {
        try {
            const response = await fetch('https://ecopell.ledscreen.rs/core/get-periodi/');
            const result = await response.json();
            setSviPeriodi(result.periodi || []);
        } catch (err) { console.error("Greška periodi"); }
    };

    const ucitajVozila = async () => {
        try {
            const response = await fetch('https://ecopell.ledscreen.rs/core/company-vehicles/');
            const result = await response.json();
            setVozilaInfo(Array.isArray(result) ? result : (result.results || []));
        } catch (err) { console.error("Greška vozila"); }
    };

    const zaustaviSkriptu = () => {
        if (abortControllerRef.current) {
            abortControllerRef.current.abort();
            setLogovi(prev => prev + "\n\nKORISNIK: Zaustavljanje skripte...\nSISTEM: Proces je prekinut.");
            setIsGenerating(false);
            setIsFinished(true);
        }
    };

    const handleUpload = async (e) => {
        e.preventDefault();
        if (!selectedFile) return;
        const formData = new FormData();
        formData.append('csvfile', selectedFile);
        try {
            const response = await fetch('https://ecopell.ledscreen.rs/core/upload-isplate/', { method: 'POST', body: formData });
            const result = await response.json();
            if (response.ok) {
                setPeriod(result.period || '');
                const fiksniRadnici = [
                    { id: 1, radnik: 'Branimir Tankosic', broj_dana: 0, cena: 8000, iznos_rsd: 0 },
                    { id: 2, radnik: 'Milos Brocic', broj_dana: 0, cena: 8000, iznos_rsd: 0 }
                ];
                const ostaliIzExcela = (result.stavke || []).map((item, index) => ({
                    ...item,
                    id: index + 3 
                }));
                setPodaci([...fiksniRadnici, ...ostaliIzExcela]);
                setShowUploadModal(false);
            }
        } catch (err) { alert("Greška upload."); }
    };

    const generisiTabeluZaKonzolu = (plan) => {
        if (!plan || plan.length === 0) return "";
        let tableStr = "\n\n" + "=".repeat(110) + "\n";
        tableStr += " PREGLED GENERISANOG PLANA (RADNICI PO VOZILIMA)\n";
        tableStr += "=".repeat(110) + "\n";

        // Unikatni datumi iz plana
        const sviDatumi = [...new Set(plan.flatMap(t => {
            let dates = [];
            let curr = new Date(t.od);
            let end = new Date(t.do);
            while(curr <= end) { dates.push(curr.toISOString().split('T')[0]); curr.setDate(curr.getDate()+1); }
            return dates;
        }))].sort();

        // Unikatna vozila prisutna u planu
        const unikatnaVozilaIds = [...new Set(plan.map(t => t.v_id))].sort((a,b) => a-b);
        
        // Zaglavlje sa nazivima vozila
        tableStr += "Datum      | ";
        unikatnaVozilaIds.forEach(vid => {
            const v = vozilaInfo.find(vObj => vObj.id === vid);
            const vLabel = v ? `${v.naziv}` : `ID:${vid}`;
            tableStr += `${vLabel.substring(0, 15).padEnd(16)} | `;
        });
        tableStr += "\n" + "-".repeat(110) + "\n";

        // Redovi po datumima
        sviDatumi.forEach(d => {
            const [ m, day] = d.split('-');
            tableStr += `${day}.${m}.      | `;
            unikatnaVozilaIds.forEach(vid => {
                const tura = plan.find(t => t.v_id === vid && d >= t.od && d <= t.do);
                if (tura) {
                    const txt = `${tura.radnici.length} radnika`;
                    tableStr += `${txt.padEnd(16)} | `;
                } else {
                    tableStr += " ".repeat(16) + " | ";
                }
            });
            tableStr += "\n";
        });
        tableStr += "=".repeat(110) + "\n";
        return tableStr;
    };

    const handleGenerateTerenFinal = async (e, forcedPeriod = null) => {
        if (e) e.preventDefault();
        const pZaGenerisanje = forcedPeriod || e.target.periodSelect.value;
        if (!pZaGenerisanje) return;
        
        setTargetPeriod(pZaGenerisanje);
        setGeneratedPlan(null); 
        setLogovi('SISTEM: Inicijalizacija algoritma...\n');
        setIsGenerating(true);
        setIsFinished(false);
        setShowGenerateModal(false);
        setShowStats(false); 

        abortControllerRef.current = new AbortController();

        try {
            const response = await fetch('https://ecopell.ledscreen.rs/core/run-generate-teren/', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ period: pZaGenerisanje, organization_id: 1, od_mesta_id: 1 }),
                signal: abortControllerRef.current.signal
            });

            const reader = response.body.getReader();
            const decoder = new TextDecoder();
            let fullLog = "";

            while (true) {
                const { value, done } = await reader.read();
                if (done) break;
                const chunk = decoder.decode(value, { stream: true });
                fullLog += chunk;
                
                // Sakrivamo JSON dok se učitava
                if (!fullLog.includes("REZULTAT_START")) {
                    setLogovi((prev) => prev + chunk);
                }
            }

            if (fullLog.includes("REZULTAT_START")) {
                const parts = fullLog.split("REZULTAT_START");
                const initialLogs = parts[0];
                const jsonContent = parts[1].split("REZULTAT_END")[0].trim();
                const plan = JSON.parse(jsonContent);
                
                setGeneratedPlan(plan);
                // Spajamo parametre sa početka i novu nacrtanu tabelu
                setLogovi(initialLogs + generisiTabeluZaKonzolu(plan) + "\nSISTEM: Plan je uspešno generisan u memoriji.");
            }

            setIsGenerating(false);
            setIsFinished(true);
        } catch (err) {
            if (err.name === 'AbortError') {
                console.log("Prekinuto");
            } else {
                setLogovi((prev) => prev + "\nKRITIČNA GREŠKA: Prekid komunikacije sa serverom.");
                setIsGenerating(false);
                setIsFinished(true);
            }
        }
    };

const potvrdiUpisUBazu = async () => {
        if (!targetPeriod || !generatedPlan) {
            setLogovi(prev => prev + "\nGREŠKA: Plan nije generisan ili period nije izabran.\n");
            return;
        }

        setLogovi(prev => prev + "\n\nSISTEM: Šaljem komandu za upis u bazu...\n");
        setIsGenerating(true);
        setIsFinished(false);

        try {
            const response = await fetch('https://ecopell.ledscreen.rs/core/save-generated-plan/', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ 
                    period: targetPeriod,
                    plan: generatedPlan, 
                    organization_id: 1, 
                    od_mesta_id: 1      
                })
            });

            const reader = response.body.getReader();
            const decoder = new TextDecoder();

            while (true) {
                const { value, done } = await reader.read();
                if (done) break;
                const chunk = decoder.decode(value, { stream: true });
                setLogovi((prev) => prev + chunk);
            }
            
            setIsGenerating(false);
            setIsFinished(true);
            setGeneratedPlan(null); 
        } catch (err) {
            setLogovi(prev => prev + "\nGREŠKA: Upis nije uspeo.");
            setIsGenerating(false);
        }
    };

    const handleGeneratePdfModalSubmit = async (e) => {
        e.preventDefault();
        const pZaPdf = e.target.periodSelect.value;
        if (!pZaPdf) return;
        setLogovi('PDF ENGINE: Priprema radnih naloga...\n');
        setIsGenerating(true);
        setIsFinished(false);
        setShowPdfModal(false);
        setShowStats(false); 
        try {
            const response = await fetch('https://ecopell.ledscreen.rs/core/generate-pdf-statistika/', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ period: pZaPdf }),
            });
            const reader = response.body.getReader();
            const decoder = new TextDecoder();
            while (true) {
                const { value, done } = await reader.read();
                if (done) break;
                setLogovi((prev) => prev + decoder.decode(value, { stream: true }));
            }
            setIsGenerating(false);
            setIsFinished(true);
        } catch (err) {
            setLogovi((prev) => prev + "\nGREŠKA: Generisanje nije uspelo.");
            setIsGenerating(false);
            setIsFinished(true);
        }
    };

    const pokreniUcitavanjeStatistike = async (e) => {
        if (e) e.preventDefault();
        const izabraniPeriod = e ? e.target.periodSelect.value : statsPeriod;
        if (!izabraniPeriod) return;
        try {
            const response = await fetch(`https://ecopell.ledscreen.rs/core/get-teren-stats/?period=${izabraniPeriod}`);
            const result = await response.json();
            if (response.ok) {
                setStatsPeriod(izabraniPeriod);
                setStats(result);
                setStatsEmpty(result.radnici.length === 0);
                setShowStats(true);
                setShowStatsModal(false);
                setLogovi('');
            }
        } catch (err) { alert("Greška statistika"); }
    };

    const ucitajPodatkePerioda = async (e) => {
        e.preventDefault();
        const izabraniPeriod = e.target.periodSelect.value;
        if (!izabraniPeriod) return;
        try {
            const response = await fetch(`https://ecopell.ledscreen.rs/core/get-period-data/?period=${izabraniPeriod}`);
            const result = await response.json();
            if (response.ok) {
                setPodaci(result.stavke.map((item, index) => ({ ...item, id: index + 1 })));
                setPeriod(izabraniPeriod);
                setShowViewModal(false);
            }
        } catch (err) { alert("Greška učitavanje."); }
    };

    const handleSave = async (e) => {
        e.preventDefault();
        if (!period) { alert("Unesite period!"); return; }
        const stavkeZaSlanje = podaci.map((item) => ({
            radnik: item.radnik, iznos_rsd: item.iznos_rsd || 0, broj_dana: item.broj_dana || 0, cena: item.cena || 0
        }));
        try {
            const response = await fetch('https://ecopell.ledscreen.rs/core/save-isplate/', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ stavke: stavkeZaSlanje, period: period }),
            });
            if (response.ok) { alert("Snimljeno!"); setPodaci([]); setPeriod(''); setShowSaveModal(false); ucitajPeriode(); }
        } catch (err) { alert("Greška snimanje."); }
    };

    const handleDeletePeriod = async (e) => {
        e.preventDefault();
        const pZaBrisanje = e.target.periodSelect.value;
        if (!pZaBrisanje) return;
        if (window.confirm(`Obrisati SVE podatke za ${pZaBrisanje}?`)) {
            try {
                const response = await fetch('https://ecopell.ledscreen.rs/core/delete-period/', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ period: pZaBrisanje }),
                });
                if (response.ok) { alert("Obrisano"); setShowDeleteModal(false); ucitajPeriode(); }
            } catch (err) { alert("Greška brisanje."); }
        }
    };

    const handleEdit = (id, field, value) => {
        setPodaci(podaci.map(item => {
            if (item.id === id) {
                const updatedItem = { ...item, [field]: value };
                if (field === 'broj_dana' || field === 'cena') {
                    updatedItem.iznos_rsd = (parseFloat(updatedItem.broj_dana) || 0) * (parseFloat(updatedItem.cena) || 0);
                }
                return updatedItem;
            }
            return item;
        }));
    };

    const dodajRadnika = () => {
        const noviId = podaci.length > 0 ? Math.max(...podaci.map(p => p.id)) + 1 : 1;
        setPodaci([...podaci, { id: noviId, radnik: '', broj_dana: 0, cena: 8000, iznos_rsd: 0 }]);
        setEditingId(noviId);
    };

    const obrisiRed = (id) => { if (window.confirm("Obriši ovaj red?")) setPodaci(podaci.filter(p => p.id !== id)); };
    const ocistiKonzolu = () => { setLogovi(''); setIsFinished(false); setGeneratedPlan(null); };
    const formatirajDatum = (dateStr) => { if (!dateStr) return ""; const [year, month, day] = dateStr.split('-'); return `${day}.${month}.${year}.`; };
    const formatRadnikTekst = (n) => { if (!n || n === 0) return <span style={{color: '#444'}}>---</span>; return <span>{n} radnika</span>; };

    const sortData = (data, config) => {
        const sorted = [...data];
        sorted.sort((a, b) => {
            let valA = a[config.key];
            let valB = b[config.key];
            if (['id', 'broj', 'suma', 'vozila'].includes(config.key)) {
                valA = parseFloat(valA) || 0;
                valB = parseFloat(valB) || 0;
            }
            if (valA < valB) return config.direction === 'asc' ? -1 : 1;
            if (valA > valB) return config.direction === 'asc' ? 1 : -1;
            return 0;
        });
        return sorted;
    };

    const toggleSortRadnici = (key) => { setSortStatsRadnik(prev => ({ key, direction: prev.key === key && prev.direction === 'asc' ? 'desc' : 'asc' })); };
    const toggleSortDani = (key) => { setSortStatsDani(prev => ({ key, direction: prev.key === key && prev.direction === 'asc' ? 'desc' : 'asc' })); };
    const sortiraniRadniciStats = useMemo(() => sortData(stats.radnici, sortStatsRadnik), [stats.radnici, sortStatsRadnik]);
    const sortiraniDaniStats = useMemo(() => sortData(stats.po_danima, sortStatsDani), [stats.po_danima, sortStatsDani]);
    
    const prosekVozila = useMemo(() => {
        if (stats.po_danima.length === 0) return 0;
        return (stats.po_danima.reduce((sum, d) => sum + d.vozila, 0) / stats.po_danima.length).toFixed(2);
    }, [stats.po_danima]);

    const ukupnoStatsDnevnica = useMemo(() => stats.radnici.reduce((sum, r) => sum + (parseInt(r.broj) || 0), 0), [stats.radnici]);
    const ukupnoStatsSumaRsd = useMemo(() => stats.radnici.reduce((sum, r) => sum + (parseFloat(r.suma) || 0), 0), [stats.radnici]);
    const ukupnoDnevnica = podaci.reduce((sum, d) => sum + (parseFloat(d.broj_dana) || 0), 0);
    const ukupnaSumaRsd = podaci.reduce((sum, d) => sum + (parseFloat(d.iznos_rsd) || 0), 0);

    const thStyle = { padding: '10px 15px', border: '1px solid #1a2a4a', backgroundColor: '#162447', color: '#3366ff', fontSize: '14px', textAlign: 'center', cursor: 'pointer' };
    const tdStyle = { padding: '10px 15px', border: '1px solid #1a2a4a', fontSize: '14px', textAlign: 'center' };
    const buttonStyle = { backgroundColor: 'white', color: '#1a2a4a', border: 'none', padding: '6px 14px', borderRadius: '6px', cursor: 'pointer', fontWeight: 'bold', display: 'flex', alignItems: 'center', gap: '8px', fontSize: '13px' };
    const stopButtonStyle = { backgroundColor: '#ff4d4d', color: 'white', border: 'none', padding: '6px 14px', borderRadius: '6px', cursor: 'pointer', fontWeight: 'bold', display: 'flex', alignItems: 'center', gap: '8px', fontSize: '13px' };
    const modalOverlayStyle = { position: 'fixed', top:0, left:0, width:'100%', height:'100%', backgroundColor:'rgba(0,0,0,0.85)', display:'flex', justifyContent:'center', alignItems:'center', zIndex:9999 };
    const inputStyle = { width: '100%', padding: '12px', marginBottom: '15px', backgroundColor: '#050a1a', border: '1px solid #1a2a4a', color: 'white', boxSizing: 'border-box', fontSize: '14px' };
    const modalContentStyle = { backgroundColor:'#0a132b', padding:'30px', borderRadius:'10px', width:'450px', border:'1px solid #1a2a4a' };
    const modalButtonStyle = { padding: '10px 25px', backgroundColor: 'white', color: '#1a2a4a', border: 'none', borderRadius: '4px', cursor: 'pointer', fontWeight: 'bold' };
    const modalCancelStyle = { background: 'none', color: 'white', border: 'none', cursor: 'pointer', marginRight: '15px' };

    return (
        <div style={{padding: '20px', color: 'white'}}>
            <div style={{display: 'flex', justifyContent: 'flex-start', alignItems: 'center', marginBottom: '20px', gap: '15px'}}>
                <h2 style={{margin:0, fontSize: '20px'}}><i className="fas fa-file-invoice-dollar"></i> {period ? " Obračun za " + period : ' Trenutni Obračun'}</h2>
                <button onClick={() => setShowViewModal(true)} style={buttonStyle}>Pogledaj</button>
                <button onClick={() => setShowUploadModal(true)} style={buttonStyle}>Import Excel</button>
                <button onClick={dodajRadnika} style={buttonStyle}>Dodaj radnika</button>
                <button onClick={() => setShowSaveModal(true)} style={buttonStyle}>Snimi u bazu</button>
                
                {!isGenerating ? (
                    <button onClick={() => setShowGenerateModal(true)} style={buttonStyle}>Generiši Teren</button>
                ) : (
                    <button onClick={zaustaviSkriptu} style={stopButtonStyle}><i className="fas fa-stop"></i> ZAUSTAVI RAD</button>
                )}

                <button onClick={() => setShowStatsModal(true)} style={buttonStyle}><i className="fas fa-chart-bar"></i> Vidi Statistiku</button>
                <button onClick={() => setShowPdfModal(true)} style={buttonStyle}>Generiši PDF</button>
                <button onClick={() => setShowDeleteModal(true)} style={buttonStyle}>Briši period</button>
            </div>

            <table style={{width: '100%', borderCollapse: 'collapse', backgroundColor: '#0a132b'}}>
                <thead>
                    <tr>
                        <th style={{...thStyle, cursor:'default'}}>ID</th>
                        <th style={{...thStyle, textAlign: 'left', cursor:'default'}}>Radnik</th>
                        <th style={{...thStyle, cursor:'default'}}>Broj dnevnica</th>
                        <th style={{...thStyle, cursor:'default'}}>Cena</th>
                        <th style={{...thStyle, cursor:'default'}}>Iznos (RSD)</th>
                        <th style={{...thStyle, cursor:'default'}}>Akcije</th>
                    </tr>
                </thead>
                <tbody>
                    {podaci.map((d) => (
                        <tr key={d.id}>
                            <td style={tdStyle}>{d.id}</td>
                            <td style={{...tdStyle, textAlign: 'left'}}>{editingId === d.id ? <select value={d.radnik} onChange={(e) => handleEdit(d.id, 'radnik', e.target.value)} style={inputStyle}><option value="">---Izaberi---</option>{sviRadnici.map(r => <option key={r} value={r}>{r}</option>)}</select> : d.radnik}</td>
                            <td style={tdStyle}>{editingId === d.id ? <input type="number" value={d.broj_dana} onChange={(e) => handleEdit(d.id, 'broj_dana', e.target.value)} style={inputStyle} /> : d.broj_dana}</td>
                            <td style={tdStyle}>{editingId === d.id ? <input type="number" value={d.cena} onChange={(e) => handleEdit(d.id, 'cena', e.target.value)} style={inputStyle} /> : d.cena}</td>
                            <td style={tdStyle}>{parseFloat(d.iznos_rsd || 0).toLocaleString('sr-RS')}</td>
                            <td style={tdStyle}>
                                <div style={{display: 'flex', gap: '10px', justifyContent: 'center'}}>
                                    {editingId === d.id ? <button onClick={() => setEditingId(null)} style={{backgroundColor: '#28a745', color: 'white', padding: '4px 8px', borderRadius: '4px', border: 'none'}}>OK</button> : <button onClick={() => setEditingId(d.id)} style={{background: 'none', border: 'none', color: '#ffcc00'}}><i className="fas fa-edit"></i></button>}
                                    <button onClick={() => obrisiRed(d.id)} style={{background: 'none', border: 'none', color: '#ff4d4d'}}><i className="fas fa-trash"></i></button>
                                </div>
                            </td>
                        </tr>
                    ))}
                    {podaci.length > 0 && (
                        <tr style={{backgroundColor: '#162447', fontWeight: 'bold'}}>
                            <td colSpan="2" style={{...tdStyle, textAlign: 'right'}}>UKUPNO:</td>
                            <td style={tdStyle}>{ukupnoDnevnica} dnevnica</td>
                            <td style={tdStyle}></td>
                            <td style={tdStyle}>{ukupnaSumaRsd.toLocaleString('sr-RS')} RSD</td>
                            <td style={tdStyle}></td>
                        </tr>
                    )}
                </tbody>
            </table>

            <LogConsole isGenerating={isGenerating} logovi={logovi} isFinished={isFinished} ocistiKonzolu={ocistiKonzolu} logRef={logRef} />

            {/* DUGMAD ZA POTVRDU ILI PONAVLJANJE */}
            {generatedPlan && isFinished && (
                <div style={{display: 'flex', justifyContent: 'center', gap: '20px', padding: '20px', backgroundColor: '#0d1b3e', borderRadius: '8px', border: '2px solid #00ff00', marginTop: '20px'}}>
                    <button onClick={potvrdiUpisUBazu} style={{padding: '15px 30px', backgroundColor: '#28a745', color: 'white', fontWeight: 'bold', fontSize: '16px', border: 'none', cursor: 'pointer', borderRadius: '5px'}}>
                        <i className="fas fa-check-circle"></i> POTVRDI I UPIŠI U BAZU
                    </button>
                    <button onClick={() => handleGenerateTerenFinal(null, targetPeriod)} style={{padding: '15px 30px', backgroundColor: '#ffcc00', color: '#1a2a4a', fontWeight: 'bold', fontSize: '16px', border: 'none', cursor: 'pointer', borderRadius: '5px'}}>
                        <i className="fas fa-sync"></i> NE SVIĐA MI SE, POKRENI PONOVO
                    </button>
                </div>
            )}

            {showStats && !statsEmpty && !isGenerating && !logovi && (
                <>
                    <div style={{marginTop: '40px', marginBottom: '20px', padding: '15px', backgroundColor: '#162447', borderRadius: '8px', border: '1px solid #3366ff'}}>
                        <h2 style={{margin: 0, color: '#00ff00', fontSize: '22px'}}>Statistika za period: {statsPeriod}</h2>
                    </div>
                    <StatsTables sortiraniRadniciStats={sortiraniRadniciStats} toggleSortRadnici={toggleSortRadnici} ukupnoStatsDnevnica={ukupnoStatsDnevnica} ukupnoStatsSumaRsd={ukupnoStatsSumaRsd} sortiraniDaniStats={sortiraniDaniStats} toggleSortDani={toggleSortDani} prosekVozila={prosekVozila} formatirajDatum={formatirajDatum} thStyle={thStyle} tdStyle={tdStyle} stats={stats} />
                    <PlanTable stats={stats} formatirajDatum={formatirajDatum} formatRadnikTekst={formatRadnikTekst} ukupnoStatsDnevnica={ukupnoStatsDnevnica} thStyle={thStyle} tdStyle={tdStyle} />
                </>
            )}

            {showViewModal && <div style={modalOverlayStyle}><div style={modalContentStyle}><h3>Pogledaj period</h3><form onSubmit={ucitajPodatkePerioda}><select name="periodSelect" style={inputStyle} required><option value="">Izaberi...</option>{sviPeriodi.map(p => <option key={p} value={p}>{p}</option>)}</select><div style={{display:'flex', justifyContent:'flex-end'}}><button type="button" onClick={() => setShowViewModal(false)} style={modalCancelStyle}>Otkaži</button><button type="submit" style={modalButtonStyle}>Prikaži</button></div></form></div></div>}
            {showGenerateModal && <div style={modalOverlayStyle}><div style={modalContentStyle}><h3>Generiši teren</h3><form onSubmit={handleGenerateTerenFinal}><select name="periodSelect" style={inputStyle} required><option value="">Izaberi...</option>{sviPeriodi.map(p => <option key={p} value={p}>{p}</option>)}</select><div style={{display:'flex', justifyContent:'flex-end'}}><button type="button" onClick={() => setShowGenerateModal(false)} style={modalCancelStyle}>Otkaži</button><button type="submit" style={modalButtonStyle}>Pokreni</button></div></form></div></div>}
            {showPdfModal && <div style={modalOverlayStyle}><div style={modalContentStyle}><h3>Generiši PDF</h3><form onSubmit={handleGeneratePdfModalSubmit}><select name="periodSelect" style={inputStyle} required><option value="">Izaberi...</option>{sviPeriodi.map(p => <option key={p} value={p}>{p}</option>)}</select><div style={{display:'flex', justifyContent:'flex-end'}}><button type="button" onClick={() => setShowPdfModal(false)} style={modalCancelStyle}>Otkaži</button><button type="submit" style={modalButtonStyle}>Generiši</button></div></form></div></div>}
            {showStatsModal && <div style={modalOverlayStyle}><div style={modalContentStyle}><h3>Vidi Statistiku</h3><form onSubmit={pokreniUcitavanjeStatistike}><select name="periodSelect" style={inputStyle} required><option value="">Izaberi...</option>{sviPeriodi.map(p => <option key={p} value={p}>{p}</option>)}</select><div style={{display:'flex', justifyContent:'flex-end'}}><button type="button" onClick={() => setShowStatsModal(false)} style={modalCancelStyle}>Otkaži</button><button type="submit" style={modalButtonStyle}>Prikaži</button></div></form></div></div>}
            {showUploadModal && <div style={modalOverlayStyle}><div style={modalContentStyle}><h3>Uvoz Excel tabele</h3><form onSubmit={handleUpload}><input type="file" onChange={(e) => setSelectedFile(e.target.files[0])} accept=".xlsx, .xls" style={{...inputStyle, padding: '8px'}} /><div style={{display:'flex', justifyContent:'flex-end'}}><button type="button" onClick={() => setShowUploadModal(false)} style={modalCancelStyle}>Otkaži</button><button type="submit" style={modalButtonStyle}>Učitaj</button></div></form></div></div>}
            {showSaveModal && <div style={modalOverlayStyle}><div style={modalContentStyle}><h3>Snimanje obračuna</h3><form onSubmit={handleSave}><input type="text" value={period} onChange={(e) => setPeriod(e.target.value)} placeholder="Naziv perioda..." style={inputStyle} required/><div style={{display:'flex', justifyContent:'flex-end'}}><button type="button" onClick={() => setShowSaveModal(false)} style={modalCancelStyle}>Otkaži</button><button type="submit" style={modalButtonStyle}>Sačuvaj</button></div></form></div></div>}
            {showDeleteModal && <div style={modalOverlayStyle}><div style={modalContentStyle}><h3>Izbriši period</h3><form onSubmit={handleDeletePeriod}><select name="periodSelect" style={inputStyle} required><option value="">Izaberi...</option>{sviPeriodi.map(p => <option key={p} value={p}>{p}</option>)}</select><div style={{display:'flex', justifyContent:'flex-end'}}><button type="button" onClick={() => setShowDeleteModal(false)} style={modalCancelStyle}>Otkaži</button><button type="submit" style={modalButtonStyle}>Obriši</button></div></form></div></div>}
        </div>
    );
};

export default Dnevnice;